var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.375C8.34 3.375 7.5 2.535 7.5 1.5H6.75C3.75 1.5 3 2.25 3 5.25L3 12.75C3 15.75 3.75 16.5 6.75 16.5H7.125C7.125 15.465 7.965 14.625 9 14.625C10.035 14.625 10.875 15.465 10.875 16.5H11.25C14.25 16.5 15 15.75 15 12.75V5.25C15 2.25 14.25 1.5 11.25 1.5C11.25 2.535 10.41 3.375 9.375 3.375Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5L15 10.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.f2f139437e2c7eaa36309084ea089de7.svg";
export { ForwardRef as ReactComponent };